import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01cc2e1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "labeled-button-wrapper",
  ref: "wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "tag-label",
          ref: "badge"
        }, _toDisplayString(_ctx.label), 513))
      : _createCommentVNode("", true)
  ], 512))
}